export const CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE = 'CHAT_VIEW_LAST_GROUP_ID_LOCALSTORAGE';
export const CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE = 'CHAT_VIEW_LAST_CHAT_ID_LOCALSTORAGE';
